/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultTaskSiteInfo } from '../models/list-query-result-task-site-info';
@Injectable({
  providedIn: 'root',
})
class TaskSiteService extends __BaseService {
  static readonly GetAllPath = '/api/tasks/site-locations';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param ids undefined
   * @return Success
   */
  GetAllResponse(ids?: Array<string>): __Observable<__StrictHttpResponse<ListQueryResultTaskSiteInfo>> {
    let __params = [];
    let __headers = new HttpHeaders();
    let __body: any = {};
    (ids || []).forEach(val => {if (val != null)  __params.push(val.toString())});
    __body.ids=__params
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tasks/site-locations`,
      __body,
      {
        headers: __headers,
        params: null,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskSiteInfo>;
      })
    );
  }
  /**
   * @param ids undefined
   * @return Success
   */
  GetAll(ids?: Array<string>): __Observable<ListQueryResultTaskSiteInfo> {
    return this.GetAllResponse(ids).pipe(
      __map(_r => _r.body as ListQueryResultTaskSiteInfo)
    );
  }
}

module TaskSiteService {
}

export { TaskSiteService }
